import {NavbarMode} from '@navbar-unlogged-types';

export type NavbarModeUrlMap = {
    readonly [NavbarMode.FREELANCER]: {readonly urls: readonly string[]};
};

export const NAVBAR_MODE_URL_MAP: NavbarModeUrlMap = {
    [NavbarMode.FREELANCER]: {
        urls: ['/freelancer', '/c/freelancers'],
    },
};

export function normalizeNavbarPath(path: string): string {
    if (path === '/') {
        return path;
    }

    return path.replace(/\/+$/, '') || '/';
}

function assertNoDuplicateNavbarModeUrls(map: NavbarModeUrlMap): void {
    const seen = new Map<string, NavbarMode>();

    for (const mode of Object.keys(map) as (keyof NavbarModeUrlMap)[]) {
        for (const url of map[mode].urls) {
            const normalized = normalizeNavbarPath(url);
            const existing = seen.get(normalized);
            if (existing !== undefined && existing !== mode) {
                throw new Error(`Navbar mode URL "${normalized}" is mapped to both "${existing}" and "${mode}".`);
            }
            if (existing === undefined) {
                seen.set(normalized, mode);
            }
        }
    }
}

assertNoDuplicateNavbarModeUrls(NAVBAR_MODE_URL_MAP);
